module.exports = {"youtubeVideoId":"b4tFdH5cZN0","label":"Leggende di Strada"}